import { Base } from '@studiometa/js-toolkit';

/**
 * StickyBar
 */
export default class ProductStickyBar extends Base {
  static config = {
    name: 'ProductStickyBar',
  };

  isVisible = false;

  maxScroll = 0;

  footerHeight = 0;

  addToCart = null;

  isAddToCartOutOfView = false;

  /**
   *
   */
  mounted() {
    this.footerHeight = document.querySelector('footer').offsetHeight;
    this.addToCart = document.querySelector('#main-add-to-cart');
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @returns {void}
   */
  scrolled({ y }) {
    console.log(this.isAddToCartOutOfView);
    this.rect = this.addToCart.getBoundingClientRect();
    this.isAddToCartOutOfView = this.rect.bottom < 0;
    this.maxScroll = document.body.scrollHeight - window.innerHeight - this.footerHeight;

    if (this.isVisible && (!this.isAddToCartOutOfView || y > this.maxScroll)) {
      this.$el.classList.add('translate-y-full');
      this.isVisible = false;
      return;
    }

    if (!this.isVisible && this.isAddToCartOutOfView && y <= this.maxScroll) {
      this.$el.classList.remove('translate-y-full');
      this.isVisible = true;
    }
  }
}
